export const COMPONENT_CONTAINER_IDENTIFIER = 'conektaComponentContainer';

export const PLUGIN_ONLY_METADATA_KEYS = ['shopify_order'];
export const MAX_LENGTH_MERCHANT_NAME = 30;

export const defaultComponentOptions = {
  backgroundMode: 'lightMode',
  colorPrimary: '#081133',
  colorText: '#585987',
  colorLabel: '#585987',
  inputType: 'minimalMode',
};
